var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"sibebar-title text-left text-black"},[_vm._v(" "+_vm._s(_vm.$t('profile-tags'))+" ")]),_c('base-chips-input',{attrs:{"value":_vm.contactTags,"suggestions":_vm.tagNames,"placeholder":_vm.$t('add-tag'),"label":_vm.$t('profile-tags')},on:{"input":_vm.updateTags}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }